<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">CRM管理</Breadcrumb-item>
        <Breadcrumb-item>首次跟踪记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div style="margin-top: 10px">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col :xs="24" :sm="12" :md="8">
            <Form-item label="分配时间:">
              <Row :gutter="8">
                <Col span="16">
                  <Date-picker
                    type="date"
                    format="yyyy-MM-dd"
                    placeholder="请选择日期"
                    @on-change="linkTimeStartChange"
                    :value="queryParam.linkStartTimeDate"
                    style="width: 100%;"
                  ></Date-picker>
                </Col>
                <Col span="2" style="text-align: center">-</Col>
                <Col span="16">
                  <Date-picker
                    type="date"
                    format="yyyy-MM-dd"
                    placeholder="请选择日期"
                    @on-change="linkTimeEndChange"
                    :value="queryParam.linkEndTimeDate"
                    style="width: 100%;"
                  ></Date-picker>
                </Col>
              </Row>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="12" :md="6">
            <Form-item label="学生信息:">
              <Input placeholder="ID/手机号" v-model="queryParam.stdSearchKey" style="width: 100%;"></Input>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="12" :md="6">
            <Form-item label="课程顾问" prop="studyAdviserName">
              <admin-user-select :status="1" adminGroupCode="adviser"
                                 v-model="queryParam.adviserId" style="width: 100%;"></admin-user-select>
            </Form-item>
          </Col>
        </Row>

        <Row>
          <Button type="primary" @click="search()">搜索</Button>
<!--          <Button type="primary" :loading="cancelLoading" :disable="cancelLoading" icon=""-->
<!--                  @click="batchCancel">批量提醒-->
<!--          </Button>-->
        </Row>
      </Form>

    </div>
    <List style="margin-top: 10px" :tableColumns="assignTitle" listUrl="/adviser/first-follow-page"
          :params="queryParam" :onLoading="onLoading" :reload="reload" @on-selection-change="selectionChange"></List>
  </div>
</template>
<script>
import AdviserFloatModal from '../common/AdviserFloatModal.vue'

export default {
  components: {
    AdviserFloatModal
  },
  data() {
    let $constant = this.$constant
    return {
      exportLoading: false,
      cancelLoading: false,
      showAssignAdviserModal: false,
      selectionUser: [],
      searchLoading: false,
      editUser: false,
      reload: 0,
      uid: null,
      queryParam: {
        recordsSource: '',
        stdStatus: '',
        connectionStatus: '',
        regStartTimeDate: '',
        regEndTimeDate: '',
        linkStartTimeDate: '',
        linkEndTimeDate: '',
        studentTag: null,
        bookTestId: '',
        stdSearchKey: '',
        nickName: '',
        studyAdviserId: '',
        studentLessonState: '',
        adviserId: null,
        adviserIds: [],
        teamType: null,
      },
      studyAdvisers: [],
      assignTitle: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left',
        },
        {
          title: '学生ID/姓名',
          // width: 150,
          render: (h, params) => {
            let row = params.row
            return h('span', row.uid + '-' + row.nickName)
          }
        },
        {
          title: '注册渠道',
          align: 'center',
          key: 'regType',
        },
        {
          title: '分配来源',
          // width: 100,
          render: (h, params) => {
            let recordsSource = params.row.recordsSource
            let recordsSourceEnum = $constant.getEnum($constant.recordsSource, recordsSource)
            return h('div', recordsSourceEnum && recordsSourceEnum.text)
          }
        },
        {
          title: '课程顾问',
          // width: 130,
          key: 'adviserName',
          render: (h, params) => {
            return h('span', params.row.adviserName || '未分配')
          }
        },
        {
          title: '分配人',
          align: 'center',
          key: 'assignerName',
          // width: 110,
        },
        {
          title: '分配时间',
          align: 'center',
          // width: 170,
          key: 'assignTime'
        },
        {
          title: '钉钉提醒时间',
          align: 'center',
          // width: 170,
          key: 'msgSendTime'
        },
        {
          title: '销售处理时间',
          align: 'center',
          // width: 170,
          render: (h, params) => {
            let updateTime = params.row.updateTime
            if (updateTime) {
              return h('div', [
                h('span', {style: {color: '#19be6b'}}, updateTime), // 绿色 - 已处理
                h('br'),
                h('span', {style: {color: '#19be6b'}}, '耗时:' + params.row.duration)
              ])
            } else {
              return h('div', [
                h('span', {style: {color: '#ff9900'}}, '待处理'), // 橙色 - 等待处理
                h('br'),
                h('span', {style: {color: '#ff9900'}}, params.row.duration)
              ])
            }
          }
        },
        {
          title: '销售备注',
          align: 'center',
          // width: 170,
          key: 'optRemark'
        },
        {
          title: '通话录音',
          render: (h, params) => {
            const audioUrl = params.row.audioUrl
            if (audioUrl) {
              if (audioUrl === '失败') {
                return h('span', '无录音')
              }
              return h('audio', {
                attrs: {
                  src: audioUrl,
                  controls: true // 显示播放控件
                },
                style: {
                  width: '100%'
                }
              })
            } else {
              return h('span', '无录音')
            }
          }
        },
      ],
    }
  },
  methods: {
    search() {
      this.selectionUser = []
      this.reload = new Date().getTime()
    },
    selectionChange(selection) {
      this.selectionUser = selection
    },
    getAdviserInfo(obj) {
      if (obj) {
        this.queryParam.adviserId = obj.adviserId
        this.queryParam.teamType = obj.teamType
        this.queryParam.adviserIds = obj.adviserIds
      }
    },
    onLoading(loading) {
      this.searchLoading = loading
    },
    regTimeStartChange(val) {
      this.queryParam.regStartTimeDate = val
    },
    regTimeEndChange(val) {
      this.queryParam.regEndTimeDate = val
    },
    linkTimeStartChange(val) {
      this.queryParam.linkStartTimeDate = val
    },
    linkTimeEndChange(val) {
      this.queryParam.linkEndTimeDate = val
    },
    batchCancel () {
      let self = this
      this.cancelLoading = true
      let ids = []
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (let i in this.selectionUser) {
          let dto = this.selectionUser[i]
          ids[i] = dto.id
        }
        this.$http.post('/adviser/batch-notify', {
          ids: ids
        }).then((res) => {
          self.$Message.success('提醒成功')
          self.cancelLoading = false
        }).catch((e) => {
          this.cancelLoading = false
        })
      } else {
        self.$Message.warning('请选择目标')
        this.cancelLoading = false
      }
    }
  },
  created: function () {
    // 设置分配开始时间为今天
    const date = new Date()
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    this.queryParam.linkStartTimeDate = `${year}-${month}-${day}`
  },
  mounted: function () {
    let self = this
    self.$http.get('/adminUser/listByCondition?adminGroupId=' + 4).then(function (res) {
      self.studyAdvisers = res.data
    })
    this.cmd = 1
    this.title = this.assignTitle
    this.search()
  }
}
</script>



// WEBPACK FOOTER //
// FirstFollowList.vue?301b97ae